


















































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import collect from 'collect.js'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import dayjs from 'dayjs'
import { DateHelper } from '@/modules/shared/helpers/date'
import { InvoiceModelType, InvoiceResourceModelInAdmin } from '@/modules/invoice/models/invoice-reource.model'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: { BaseButton, PriceView, AdminUserSearch, BaseCard, Checkbox, Toggle, BaseSelect, BaseInput, TagsInput }
})
export default class AdminInvoiceForm extends Vue {
  constructor(
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  @PropSync('invoice', { required: true }) invoiceSync!: InvoiceResourceModelInAdmin
  @Prop() modelTypes!: { [key in InvoiceModelType]: string }
  @Prop({ default: false }) disabledInputs: boolean
  private invoiceModelType: InvoiceModelType = InvoiceModelType.MANUAL
  private isManual: boolean = false

  $refs!: {
    refPopupDueDate: QPopupProxy,
  }

  mounted() {
    this.isManual = (this.invoiceSync.model_type === this.invoiceModelType)
  }

  get title() {
    return this.invoiceSync.title
  }

  set title(value) {
    this.$set(this.invoiceSync, 'title', value)
  }

  get userId() {
    return this.invoiceSync.user.id
  }

  set userId(value) {
    this.$set(this.invoiceSync.user, 'id', value)
  }

  get modelType() {
    return this.invoiceSync.model_type || null
  }

  set modelType(value) {
    this.$set(this.invoiceSync, 'model_type', value)
  }

  get modelId() {
    return this.invoiceSync.model_id
  }

  set modelId(value) {
    this.$set(this.invoiceSync, 'model_id', value)
  }

  get description() {
    return this.invoiceSync.description
  }

  set description(value) {
    this.$set(this.invoiceSync, 'description', value)
  }

  get dueDate() {
    return (this.invoiceSync.due_date) ? this.getJalaliDate(this.invoiceSync.due_date) : ''
  }

  set dueDate(value) {
    this.$set(this.invoiceSync, 'due_date', (value) ? this.jalaliToGregory(value) : null)
  }

  tomorrow() {
    let today = new Date()
    let tomorrow = new Date()
    return tomorrow.setDate(today.getDate() + 1)
  }

  dueDateOption(date) {
    return date >= this.getJalaliDate(this.tomorrow())
  }

  get modelTypeOptions() {
    return collect(this.modelTypes).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  jalaliToGregory(value) {
    return this.dateHelper.fromJalali(value).toTimestamp()
  }

  getJalaliDate(value) {
    return dayjs(value).format('YYYY/MM/DD')
  }

  clearDate() {
    this.$set(this.invoiceSync, 'due_date', null)
  }

}
